module.exports = __webpack_public_path__ + "img/file4.81fb6f0e.png";